import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { getAuthData } from '../../Utils/storage';
 
const RouteGuard = ({children}) => {

   function isLoggedIn() {
     const authData = getAuthData();
     return !!authData
   }
 
  
    if (!isLoggedIn()) {
        return <Navigate to="/login-email" replace />
      }else{
          return children
      }
    
    
};
 
export default RouteGuard;